module.exports = __webpack_public_path__ + "static/img/29.637533b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/29.jpg
// module id = fsE/
// module chunks = 0